<bw-action-article-legacy *ngIf="partnerIntro$ | async as partnerIntro; else spinner">
  <div header-actions>
    <ui-nav-exit-back
      [trackingDetail]="{ event_name: 'lender_alternatives_intro' }"
    ></ui-nav-exit-back>
  </div>
  <div pre-title>
    <div class="partner-logo" [style.background-image]="'url(' + cdnImgUrl + partnerIntro.imagePartner + '.png)'"></div>
  </div>
  <div header-title>
    <div class="flex mt-sm">
      <typography-legacy title-medium color="var(--primary-text)">
        <div [innerHTML]="partnerIntro.name | translate"></div>
      </typography-legacy>
    </div>
  </div>
  <div content-section>
    <typography-legacy color="var(--secondary-text)">
      <div [innerHTML]="partnerIntro.summary | translate"></div>
    </typography-legacy>

    <typography-legacy text-medium-semibold class="mb-sm mt-sm">
      {{ 'SUMMARY' | translate }}
    </typography-legacy>
    <typography-legacy color="var(--secondary-text)" style="max-width: 450px">
      <div [innerHTML]="partnerIntro.desc | translate"></div>
    </typography-legacy>
  </div>
  <div footer-actions class="mt-md">
    <button bw-button-legacy (click)="goToPartnerLegal(partnerIntro)">
      {{ 'CONTINUE_TO_CTA' | translate : { lenderName: partnerIntro.name | translate } }}
    </button>
  </div>
</bw-action-article-legacy>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
